function Landing() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-homeLanding bg-cover bg-no-repeat bg-left-bottom w-full overflow-x-hidden">
      <div className="mt-52 mb-40 w-full max-w-7xl px-10 m6:px-5 text-primary">
        <div className="bg-white flex flex-col items-center rounded-3xl w-full py-20 px-10 shadow-xl text-justify text-2xl m6:text-xl">
          <span className="text-5xl font-bold text-center">
            Qui sommes nous ?
          </span>
          <span className="mt-8">
            Nous sommes une équipe qui s'est retrouvee afin de resoudre le probleme la gestion de maintenance assistée par ordinateur (GMAO) pour les PME.
          </span>
          {/* Add little image of the coworkers */}


        </div>
      </div>
    </div>
  );
}

export default Landing;